export default "__VITE_ASSET__NGJ9ixPU__"